// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"style_tableWrapper__1Z9ha"};